import { paths } from '@mc/paths'

export const STRAIGHT_TO_QR_EXP_FLAG = 'pen-4849_v1'
export const INTEREST_EVENT_NAMES = ['Product List Viewed', 'Product Viewed']
export const STRAIGHT_TO_QR_ENABLED_PATHS = [
  paths.classPage(''),
  paths.seriesPage(''),
  paths.category(''),
  paths.categories,
  paths.subcategoryPage(''),
]
export const STRAIGHT_TO_QR_EXCLUDED_SEGMENTS = ['/episodes/', '/chapters/']
export const STRAIGHT_TO_QR_QUERY_PARAM = 'sd'

export const getStraightToQRPath = (
  categoryInterests: number[],
  subcatInterests: number[],
) =>
  `${paths.classRecommendationsResults}?categories=${categoryInterests.join(',')}&subcategories=${subcatInterests.join(',')}&${STRAIGHT_TO_QR_QUERY_PARAM}=t`
